import { createContext } from 'react';
import { homeHealthDefaultState } from './reducer';

const Context = createContext({
  ...homeHealthDefaultState,
  dispatch: (homeHealthAction?: any) => {},
});

export default Context;
